import AppUpdatePic from "./update-pic.jpg";
import Logo from "./logo.png";
import SampleAvatar from './sample-avatar.png';
import ptemplate5 from "./ptemplate-5.png";
import ptemplate6 from "./ptemplate-6.png";
import ptemplate7 from "./ptemplate-7.png";
import ptemplate8 from "./ptemplate-8.png";

export const projectTemplateImages = {
  5: ptemplate5,
  6: ptemplate6,
  7: ptemplate7,
  8: ptemplate8,
};

export { AppUpdatePic, Logo, SampleAvatar };
